export default __webpack_public_path__ + "static/media/10.2c35dab7.jpg";